import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

// Global admin auth response interceptor.
// - Refreshes the admin_token whenever the backend sends a new one.
// - Redirects to the login page on 401 so users don't see raw "Unauthorized" errors.
const originalFetch = window.fetch;
window.fetch = async function (
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  const response = await originalFetch(input, init);

  const url =
    typeof input === "string"
      ? input
      : input instanceof Request
      ? input.url
      : input.href;
  const pathname = new URL(url, window.location.origin).pathname;
  const isAdminApi =
    pathname.startsWith("/api/admin") ||
    pathname.startsWith("/api/public/admin");

  if (isAdminApi) {
    const refreshed = response.headers.get("X-Admin-Token-Refresh");
    if (refreshed) {
      localStorage.setItem("admin_token", refreshed);
    }

    if (response.status === 401 && window.location.pathname !== "/admin") {
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_user");
      window.location.replace("/admin?expired=1");
    }
  }

  return response;
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
